const config = {
  ENVIRONMENT_NAME: 'staging',
  forwoodId: {
    URL: 'https://id.staging.valeglobal.forwoodsafety.com',
    USER_TOKEN_URL: 'https://6iff88umn1.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://lztoz49vag.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'admin-container-1.11.5',
    HOSTNAME: 'https://admin.staging.valeglobal.forwoodsafety.com',
    COMPANY_MICROFRONTEND_URL: 'https://company.staging.valeglobal.forwoodsafety.com',
    PHYSICAL_LOCATION_MICROFRONTEND_URL: 'https://locations.staging.valeglobal.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.valeglobal.forwoodsafety.com',
    WEBSOCKET: 'wss://fjbp8skumh.execute-api.us-west-2.amazonaws.com/staging'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
